<template>
  <div class="info">
    <el-form
      class="form"
      label-position="right"
      label-width="200px"
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
    >
      <el-form-item label="手机号:">
        {{ initPhone(this.userPhone)
        }}<el-button
          @click="getPhoneCode"
          :disabled="disabled"
          size="mini"
          class="update"
          type="primary"
          round
          >{{ phonems }}</el-button
        >
      </el-form-item>
      <el-form-item label="验证码:" prop="phonecode">
        <el-input
          style="width: 50%"
          clearable
          v-model="ruleForm.phonecode"
          placeholder="请输入验证码"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="pass">
        <el-input
          style="width: 50%"
          type="password"
          clearable
          v-model="ruleForm.pass"
          placeholder="请输入新密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          style="width: 50%"
          type="password"
          clearable
          v-model="ruleForm.checkPass"
          placeholder="再次输入新密码"
          autocomplete="off"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          style="margin-left: 14%"
          type="primary"
          @click="nameSub()"
          :loading="isBtnLoading"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "info",
  data() {
    var validatePass = (rule, value, callback) => {
     let reg = /^[A-Za-z0-9]+$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("密码不能为特殊字符"));
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      timeNum: null,
      userPhone: "",
      isBtnLoading: false,
      ruleForm: {
        phonecode: "",
        pass: "",
        checkPass: "",
      },
      phonems: "获取验证码",
      disabled: false,
      rules: {
        phonecode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        pass: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
          {
            min: 6,
            max: 15,
            message: "长度在 6 到 15 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    ...mapGetters(["getUserInfo"]),
  },
  created() {
    if (this.getUserInfo != null) {
      this.userPhone = this.getUserInfo.cellphone;
    } else {
      let opt = {
        token: this.getToken,
        reviewer_status: 1, //审核状态(固定写1)
      };
      this.getUserInfoApi(opt)
        .then((res) => {
          if (res.data.code === 1) {
            this.userPhone = res.data.data.cellphone;
          } else {
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  methods: {
    ...mapActions({
      upDataPassword: "loginModule/upDataPassword",
      getMCode: "loginModule/getMCode",
      getUserInfoApi: "loginModule/getUserInfoApi",
    }),

    nameSub() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.isBtnLoading = true;
          let opt = {
            cellphones: this.userPhone,
            pwd1: this.ruleForm.pass,
            pwd2: this.ruleForm.checkPass,
            token: this.getToken,
            codes: this.ruleForm.phonecode,
          };
          this.upDataPassword(opt)
            .then((res) => {
              // console.log(res);
              if (res.data.code === 1) {
                this.$message({
                  message: "密码修改成功",
                  type: "success",
                });
                clearInterval(this.timeNum);
                this.disabled = false;
                this.phonems = "获取验证码";
                this.$refs["ruleForm"].resetFields();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
              this.isBtnLoading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getPhoneCode() {
      this.getMCode({ cellphones: this.userPhone })
        .then((res) => {
          // console.log(res);
          if (res.data.code === 1) {
            this.$message({
              message: "手机验证码已发送",
              type: "success",
            });
            this.phonems = "获取验证码";
          } else {
            this.$message({
              message: "获取验证码失败，请重试",
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      let counts = 60;
      this.timeNum = setInterval(() => {
        let str = "";
        if (counts > 0) {
          counts--;
          str = counts + "秒后重新获取";
          this.disabled = true;
        } else {
          str = "获取验证码";
          this.disabled = false;
          clearInterval(this.timeNum);
        }

        this.phonems = str;
      }, 1000);
    },
    initPhone(val) {
      if (val) {
        return val.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2");
      }
    },
  },
};
</script>
<style lang='scss' scoped>
::v-deep .el-upload--picture-card {
  height: 0;
  display: none;
}
.zhanghu {
  margin: 30px 0;
  font-size: 24px;
}
.bj {
  font-size: 30px;
  position: relative;
  top: 6px;
  cursor: pointer;
  margin-left: 20px;
}
.update {
  margin-left: 20px;
}
.info {
  width: 50%;
  margin: 0 auto;
  margin-top: 30px;
}
</style>